import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./clientTheme.css";
import "./Footer.css";

export default function Footer() {
  const { t } = useTranslation("footer");
  return (
    <footer className="client-footer">
      <div className="client-footer-inner">
        <div className="client-footer-brand">
          <img src="/apple-touch-icon.png" alt="Salatty" className="client-footer-logo" />
          <span className="client-footer-name">Salatty</span>
        </div>
        <p className="client-footer-tagline">{t("tagline")}</p>
        <Link to="/join" className="client-footer-link">
          {t("sellOnSalatty")}
        </Link>
        <p className="client-footer-copyright">{t("copyright", { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
}
